/** Thread + chat-surface product events (spec 68 §6.6.3, spec 59). */
import { z } from 'zod';
import { DEFAULT_SCHEMA_VER, id, openedByEnum } from './_shared.js';

export const threadEvents = {
  'thread.opened': {
    schema: z.object({
      account_id: id,
      project_id: id,
      thread_id: id,
      agent_id: id.optional(),
      opened_by: openedByEnum,
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'thread.message_sent': {
    schema: z.object({
      account_id: id,
      project_id: id,
      thread_id: id,
      agent_id: id,
      message_length: z.number().int().nonnegative(),
      has_attachments: z.boolean(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'thread.message_retried': {
    schema: z.object({ account_id: id, thread_id: id, run_id: id.optional() }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'thread.run_cancelled': {
    schema: z.object({ account_id: id, thread_id: id, run_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'thread.forked': {
    schema: z.object({
      account_id: id,
      source_thread_id: id,
      source_run_id: id,
      new_thread_id: id,
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'thread.run_replayed': {
    schema: z.object({ account_id: id, source_run_id: id, new_run_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'thread.elicitation_answered': {
    schema: z.object({ account_id: id, thread_id: id, agent_id: id.optional() }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
} as const;
